module.exports = new __parcel__URL__("from_the_roots.b12821bc.mp3").toString();